<template>
    <div class="container search">
        <div class="row">
            <div class="col-md-12">
                <h2>
                    <template v-if="company && $canEditCompany(company_id)">Manage</template>
                    Company<template v-if="company"> - {{ company.name }}</template>
                </h2>
            </div>
            <div class="col-md-12">
                <div v-if="company">
                    <a v-if="company && $canEditCompany(company_id)" :href="$laravelRoute('companies.edit', company_id)">Edit Company</a>
                    <br />
                    <br />
                    <div>
                        <strong>Name</strong> {{ company.name }}
                    </div>
                    <div>
                        <strong>Website</strong> {{ company.website }}
                    </div>
                    <div>
                        <strong>Phone</strong> {{ company.phone_number }}
                    </div>
                    <div>
                        <h2 class="mt-3">Users</h2>
                        <div>
                            <a v-if="$canManageCompany(company_id)" :href="$laravelRoute('users.create')" class="link">Add New User</a>
                        </div>
                        <div v-if="company.users && company.users.length">
                            <b-table
                                class="list-table"
                                responsive=""
                                :fields="fields"
                                :items="company.users"
                                show-empty
                            >
                                <template v-slot:empty="scope">
                                    No users
                                </template>
                                <template v-slot:cell(action)="data">
                                    <div v-if="$canManageCompany(company_id)">
                                        <a :href="$laravelRoute('users.show', data.item.id)" class="link">View</a>
                                        <a :href="$laravelRoute('users.edit', data.item.id)" class="link">Edit</a>
                                    </div>
                                </template>
                                <template v-slot:cell(manager)="data">
                                    <i v-if="data.item.privileges && data.item.privileges.is_company_manager" class="fa fa-solid fa-check text-success"></i>
                                </template>
                            </b-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {mapState, mapActions} from 'vuex'
import {splitObjKey, objLookup, getExceptionErrorMessage, getHttpValidationErrors, makeID} from '../../util/common'
import BootstrapValidation from '../../mixins/bootstrap-validation';
import axios from "axios";
import LaravelRouter from "../../thirdparty/Ziggy/route";

export default {
    props: [
        'company_id',
    ],
    async created() {
        await this.getCompany()
    },
    mixins: [BootstrapValidation],
    data() {
        return {
            messages: [],
            fields: [
                {label: 'Manager', key: 'manager', sortable: false},
                {label: 'Name', key: 'name', sortable: false},
                {label: 'Email', key: 'email', sortable: false},
                {label: 'Phone', key: 'phone_number', sortable: false},
                {label: 'Website', key: 'website', sortable: false},
            ],
            company: null,
        }
    },
    computed: {},
    mounted() {
    },
    methods: {
        async getCompany() {
            const res = await axios.get(this.$laravelRoute('companies.show', this.company_id));
            if (res && res.data && res.data.company) {
                this.company = res.data.company
                if (this.$canManageCompany(this.company_id)) {
                    this.fields.push({label: 'Action', key: 'action', sortable: false})
                }
            }
        },
        async onSubmit() {
            this.messages = [];
            this.errors = [];
            const newCompany = !this.company_id
            let action = 'companies/storeCompany'
            let data = {data: this.company}
            try {
                if (!newCompany) {
                    action = 'companies/updateCompany'
                    data = this.company
                }
                let response = await this.$store.dispatch(action, data);
                if (response) {
                    this.messages.push({type: 'success', message: response.message});
                    this.errors = [];
                } else {

                }
            } catch (error) {
                console.warn('onSubmit error: ', error);
                let message = getExceptionErrorMessage(error);
                this.messages.push({type: 'danger', message});
                let errors = getHttpValidationErrors(error);
                if (errors) {
                    this.errors = errors;
                }
            }
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/Companies/ShowCompany.vue